// Copyright (c) 2022 by Move Closer

import { Module } from 'vuex'

import { CartIdentifier } from '../../contexts/checkout/contracts'

import { State } from '../shared/contracts/store'
import { CheckoutState, MutationType } from './contracts'

import { CartModel } from './contracts/models'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const storeFactory = (): Module<CheckoutState, State> => ({
  namespaced: true,

  state: () => ({
    id: null,
    cart: null,
    loading: false,
    registering: false,
    ssoAuthenticated: false,
    ssoConsentsRequest: false
  }),

  mutations: {
    [MutationType.SetCartId] (state, cartId: CartIdentifier): void {
      state.id = cartId
    },
    [MutationType.SetCart] (state, cart: CartModel): void {
      state.cart = cart
    },
    [MutationType.SetLoading] (state, loading: boolean): void {
      state.loading = loading
    },
    [MutationType.SetRegisteringInCheckout] (state, registering: boolean): void {
      state.registering = registering
    },
    [MutationType.SetSSOAuthenticated] (state, authenticated: boolean): void {
      state.ssoAuthenticated = authenticated
    },
    [MutationType.SetSSOConsentsRequest] (state, value: boolean): void {
      state.ssoConsentsRequest = value
    }
  },

  getters: {
    /**
     * Returns the identifier of cart.
     */
    cartId: (state) => state.id,

    /**
     * Returns the cart model.
     */
    cart: (state) => state.cart,

    /**
     * Returns if cart is loading.
     */
    loading: (state) => state.loading,

    /**
     * Returns whether user is in progress of registering their account during checkout.
     */
    registering: (state) => state.registering,

    /**
     * Returns whether user has been successfully authenticated with SSO
     */
    ssoAuthenticated: (state) => state.ssoAuthenticated,

    /**
     * Retrieves a state o SSO authentication when user has to accept consents
     */
    ssoConsentsRequest: (state) => state.ssoConsentsRequest
  }
})
